export const environment = {
    production: false,
    version: '1.0.0',
    tipoUsuarioWeb: 1,
    tipoUSuarioWS: 3,
    tipoUSuarioSWS: 4,
    sistemas: ['SCI_OCRA', 'SCI_PERDIDA_TOTAL', 'SCI_POLIZAS_VIGENTES', 'SCI_FRONT', 'SCI_VALUACION']
};
